<template>
  <ResetPassForm :is-loading="isLoading" :on-submit="resetPassword" />
</template>

<script>
  import ResetPassForm from '../../components/forms/auth/SetPass';
  import recaptchaMixin from '../../mixins/recaptcha';

  export default {
    components: {
      ResetPassForm,
    },
    mixins: [recaptchaMixin],
    data() {
      return {
        isLoading: false,
        recaptcha: import.meta.env.VUE_APP_USE_RECAPTCHA,
        recaptchaKey: import.meta.env.VUE_APP_RECAPTCHA_KEY,
        langBoxPos: {
          top: 10,
          right: 10,
        },
      };
    },
    computed: {
      isRecaptchaEnabled() {
        const { recaptcha, recaptchaKey } = this;

        return recaptcha === 'true' && recaptchaKey !== '';
      },
    },
    methods: {
      async resetPassword(password) {
        const { token } = this.$route.params;
        const { email } = this.$store.getters['auth/user'];

        let recaptcha = '';
        if (this.isRecaptchaEnabled) {
          recaptcha = await this.getRecaptchaToken('reset_password');

          if (recaptcha === null) {
            return false;
          }
        }

        const query = {
          token,
          email,
          password,
          recaptcha,
        };

        this.isLoading = true;

        this.$store
          .dispatch('auth/resetPass', query)
          .then((res) => {
            this.isLoading = false;
            return res;
          })
          .catch((err) => {
            this.isLoading = false;
            return err;
          });
      },
    },
    metaInfo() {
      return {
        title: this.$t('views_reset_second_title'),
      };
    },
  };
</script>
